import React, { Dispatch, FC, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import CreateSurvey from '../Modals/AddSurveyModal/createSurvey';
import { ActionButtonOnBoardingStyled } from '../OnBoarding/styled';

interface AddSurveyActionProps {
    openCreateSurveyModal: boolean;
    setOpenCreateSurveyModal: Dispatch<SetStateAction<boolean>>;
}

const AddSurveyAction: FC<AddSurveyActionProps> = ({ setOpenCreateSurveyModal, openCreateSurveyModal }) => {
    const { t } = useTranslation('settings');

    return (
        <>
            <ActionButtonOnBoardingStyled onClick={() => setOpenCreateSurveyModal(true)} default disableRipple>
                {t('surveys.addNewSurvey')}
            </ActionButtonOnBoardingStyled>

            {openCreateSurveyModal && (
                <CreateSurvey
                    handleClose={() => setOpenCreateSurveyModal(false)}
                    openModal={openCreateSurveyModal}
                />
            )}
        </>
    );
};

export default AddSurveyAction;
